/** Páginas "Ver todos do prefixo" do Feed Joga Junto, irmãs da rota do Feed (AJ3-01, AJ3-09). */
export const ROTA_DO_FEED = '/rede-joga-junto';
export const ROTA_DOS_RECONHECIMENTOS_DO_PREFIXO = `${ROTA_DO_FEED}/reconhecimentos`;
export const ROTA_DAS_REALIZACOES_DO_PREFIXO = `${ROTA_DO_FEED}/realizacoes`;
